"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableCard = void 0;
var react_1 = __importDefault(require("react"));
var emotion_1 = require("emotion");
var styles_1 = require("../../styles");
var cardVariants_1 = require("./cardVariants");
function ClickableCard(props) {
    var _a = props.variant, variant = _a === void 0 ? 'outline' : _a, children = props.children, invalid = props.invalid, disabled = props.disabled, selected = props.selected, style = props.style, buttonProps = __rest(props, ["variant", "children", "invalid", "disabled", "selected", "style"]);
    var theme = styles_1.useTheme();
    var styles = createStyles(theme, variant, disabled, invalid, style);
    return (react_1.default.createElement("button", __assign({ type: 'button', className: styles.card, disabled: disabled, "data-variant": variant, "data-selected": selected, "data-invalid": invalid, "aria-pressed": selected }, buttonProps),
        react_1.default.createElement("div", { className: styles.inner }, children)));
}
exports.ClickableCard = ClickableCard;
var createStyles = function (theme, variant, disabled, invalid, externalStyles) {
    var baseStyles = cardVariants_1.createBaseStyles(theme);
    var variantStyles = cardVariants_1.createVariantStyles(theme)[variant];
    var clickableStyles = cardVariants_1.createClickableStyles(theme);
    return {
        card: emotion_1.css(baseStyles.card, variantStyles.base, clickableStyles, invalid && variantStyles.invalid, disabled && baseStyles.cardDisabled, disabled && variantStyles.disabled, externalStyles),
        inner: emotion_1.css(disabled && baseStyles.innerDisabled),
    };
};
//# sourceMappingURL=ClickableCard.js.map